(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
    typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
    (global = global || self, factory(global.PyroForm = {}, global.React));
}(this, function (exports, React) { 'use strict';

    var React__default = 'default' in React ? React['default'] : React;

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    var getValueFromEvent = function (event) {
        return event.currentTarget.value;
    };
    var isEvent = function (event) {
        return event && event.target && typeof event.target.value === 'string';
    };
    var isPromise = function (value) { return Boolean(value) && typeof value.then === 'function'; };
    // tslint:disable-next-line:ban-types
    var isFunction = function (value) { return typeof value === 'function'; };

    var PyroContext = React__default.createContext(undefined);
    var getPyroConsumer = function () {
        return PyroContext.Consumer;
    };
    var PyroProvider = PyroContext.Provider;

    var PyroForm = /** @class */ (function (_super) {
        __extends(PyroForm, _super);
        function PyroForm() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                values: _this.props.initialValues,
                touched: Object.keys(_this.props.initialValues).reduce(function (previousValue, currentValue) {
                    var _a;
                    return (__assign({}, previousValue, (_a = {}, _a[currentValue] = false, _a)));
                }, {}),
                errors: {},
                isSubmitting: false,
                submitCount: 0,
            };
            _this.getChangeData = function (changedName, changedValue) { return ({
                changedName: changedName,
                changedValue: changedValue,
                onChange: _this.handleChange,
            }); };
            _this.getSubmitData = function () { return ({
                onChange: _this.handleChange,
            }); };
            _this.getErrors = function () { return (__assign({}, _this.state.errors, _this.props.errors)); };
            _this.handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var onSubmit, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (e) {
                                e.preventDefault();
                            }
                            this.setTouchedAll();
                            onSubmit = this.props.onSubmit;
                            if (!onSubmit) return [3 /*break*/, 2];
                            result = onSubmit(this.state.values, this.getSubmitData());
                            if (!isPromise(result)) return [3 /*break*/, 2];
                            this.setState({
                                isSubmitting: true,
                            });
                            return [4 /*yield*/, result];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            this.setState(function (state) { return ({
                                isSubmitting: false,
                                submitCount: state.submitCount + 1,
                            }); });
                            return [2 /*return*/];
                    }
                });
            }); };
            _this.handleChange = function (name, value) {
                // Check if passed value is an event and use it's value
                var sanitizedValue = isEvent(value) ? getValueFromEvent(value) : value;
                _this.setState(function (state) {
                    var _a;
                    return ({
                        values: __assign({}, state.values, (_a = {}, _a[name] = sanitizedValue, _a)),
                    });
                }, function () {
                    _this.handleValidate();
                    if (_this.props.onChange) {
                        _this.props.onChange(_this.state.values, _this.getChangeData(name, sanitizedValue));
                    }
                });
            };
            _this.handleBlur = function (name) {
                _this.setTouched(name);
            };
            _this.setTouched = function (name) {
                _this.setState(function (state) {
                    var _a;
                    return ({
                        touched: __assign({}, state.touched, (_a = {}, _a[name] = true, _a)),
                    });
                });
            };
            _this.setTouchedAll = function () {
                for (var _i = 0, _a = Object.keys(_this.state.values); _i < _a.length; _i++) {
                    var key = _a[_i];
                    _this.setTouched(key);
                }
            };
            _this.isValid = function () {
                return Object.keys(_this.getErrors()).length === 0;
            };
            _this.handleValidate = function () {
                var _a = _this.props, onValidate = _a.onValidate, onValid = _a.onValid, onInvalid = _a.onInvalid;
                if (!onValidate)
                    return;
                _this.setState(function (state) { return ({
                    errors: onValidate(state.values),
                }); }, function () {
                    if (_this.isValid()) {
                        onValid && onValid();
                    }
                    else {
                        onInvalid && onInvalid();
                    }
                });
            };
            return _this;
        }
        PyroForm.prototype.componentDidMount = function () {
            this.handleValidate();
        };
        PyroForm.prototype.render = function () {
            var children = this.props.children;
            var contextValue = {
                values: this.state.values,
                errors: this.getErrors(),
                touched: this.state.touched,
                handleSubmit: this.handleSubmit,
                handleChange: this.handleChange,
                handleBlur: this.handleBlur,
            };
            return (React__default.createElement(PyroProvider, { value: contextValue }, isFunction(children)
                ? children({
                    handleSubmit: this.handleSubmit,
                    handleChange: this.handleChange,
                    values: this.state.values,
                    errors: this.getErrors(),
                    hasErrors: !this.isValid(),
                })
                : children));
        };
        return PyroForm;
    }(React__default.PureComponent));

    var usePyroField = function (name) {
        var context = React.useContext(PyroContext);
        if (!context) {
            // tslint:disable-next-line:no-console
            throw new Error('usePyroField hook not used in a valid PyroContext');
        }
        return {
            core: {
                name: name,
                value: context.values[name],
                onChange: function (value) { return context.handleChange(name, value); },
                onBlur: function () { return context.handleBlur(name); },
            },
            meta: {
                error: context.errors[name],
                hasError: Boolean(context.errors[name]),
                touched: context.touched[name],
            },
        };
    };

    var Form = function (props) {
        var context = React__default.useContext(PyroContext);
        if (!context) {
            // tslint:disable-next-line:no-console
            console.error('Form used in non PyroForm context');
            return null;
        }
        return React__default.createElement("form", __assign({ onSubmit: context.handleSubmit }, props));
    };

    var PyroFieldInner = /** @class */ (function (_super) {
        __extends(PyroFieldInner, _super);
        function PyroFieldInner() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleChange = function (value) {
                _this.props.handleChange && _this.props.handleChange(_this.props.name, value);
            };
            _this.handleBlur = function () {
                _this.props.handleBlur && _this.props.handleBlur(_this.props.name);
            };
            return _this;
        }
        PyroFieldInner.prototype.render = function () {
            if (!this.props.values || !this.props.errors || !this.props.touched) {
                throw new Error('Please use PyroField Components only within a PyroForm');
            }
            return this.props.children({
                core: {
                    name: this.props.name,
                    value: this.props.values[this.props.name],
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                },
                meta: {
                    error: this.props.errors[this.props.name],
                    hasError: Boolean(this.props.errors[this.props.name]),
                    touched: this.props.touched[this.props.name],
                },
            });
        };
        return PyroFieldInner;
    }(React__default.PureComponent));
    var PyroField = /** @class */ (function (_super) {
        __extends(PyroField, _super);
        function PyroField() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.PyroConsumer = getPyroConsumer();
            return _this;
        }
        PyroField.prototype.render = function () {
            var _this = this;
            return (React__default.createElement(this.PyroConsumer, null, function (contextProps) { return (React__default.createElement(PyroFieldInner, __assign({}, _this.props, contextProps))); }));
        };
        return PyroField;
    }(React__default.PureComponent));

    exports.default = PyroForm;
    exports.usePyroField = usePyroField;
    exports.Form = Form;
    exports.PyroField = PyroField;
    exports.PyroContext = PyroContext;
    exports.getPyroConsumer = getPyroConsumer;
    exports.PyroProvider = PyroProvider;
    exports.getValueFromEvent = getValueFromEvent;
    exports.isEvent = isEvent;
    exports.isPromise = isPromise;
    exports.isFunction = isFunction;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
